import React from 'react';
import { InsuranceOrderingEditTemplate } from 'themes/application/insurance-ordering/pages';
import { observer } from 'mobx-react';
import { InsuranceOrderingEditViewStore } from 'application/insurance-ordering/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new InsuranceOrderingEditViewStore(rootStore), 'insuranceOrderingEditViewStore')
@observer
class InsuranceOrderingEdit extends React.Component {
    render() {
        return <InsuranceOrderingEditTemplate {...this.props} />
    }
}

export default InsuranceOrderingEdit;